import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SliderWrapper from "jd-library/SliderWrapper";
import historyHandler from "jd-library/historyHandler";
import styles from "./item-list-slider.scss";
import ItemResult from "./ItemResult";
import NoResultFound from "../NoResultFound/NoResultFound.js";
import SearchHint from "../search-hint/SearchHint.js";
import useInfiniteScroll from "jd-library/useInfiniteScroll";
import SliderHeader from "jd-library/SliderHeader";
import useOnScroll from 'jd-library/useOnScroll';
import { pageLoad, pageLoadForIos } from "../Utills";
import Button from "jd-library/Button";
import axios from 'axios';
import { enforceStrictASCII } from "../../utills.js";

const ItemListSlider = props => {
	const subHeader = props.subHeader;
	const showCreateItem = subHeader != undefined ? subHeader : false;
	const [subHeaderShadow, toogleSubHeaderShadow] = useState(false);
	const [scrollEl, setScrollEl] = useState(null);
	const header = props.header ? props.header : {};
	const search = props.search || {};
	const minLength = search.minLength || 0;
	const { isBarcodeSearch, noRsltBarcode, scanBarcodeFunc, isScanned } = props;
	const autoSuggestion = props.autoSuggestion;
	const bodyStyle = props.autoSuggestion.bodyStyle || "";
	const [autoSuggestiontData, setAutoSuggestiontData] = useState([]);
	const searchText = search.value;
	const isMobileApp = props.isSourceJustdial && !props.isJdBusinessIOS; //props.deviceData.isAndroidApp /*|| props.deviceData.isIphoneApp*/; //349107 asked to remove barcode from ios app
	let [sliderContRef, setSliderContRef] = useState(null);
	let [fetchData, toggleFetchData] = useState(true);
	const [isScrolled, setScrolled] = useState(false);
	const itemHeader = typeof document === 'object' && document.getElementsByClassName("itemListHeader");
	const headerOffSet = itemHeader && itemHeader[0] && itemHeader[0].offsetHeight;
	const [showBarcodeInfo,toggleBarcodeInfo] = useState(false);

	const onSearchClear = () => {
		setAutoSuggestiontData([]);
		search.onChange("");
	};

	const [isFetching, setIsFetching] = useInfiniteScroll({
		scrollContainer: sliderContRef,
		loadMoreCB: () => {
			if (fetchData) {
				props.infiniteScrollCB &&
					props.infiniteScrollCB(fetch => {
						setIsFetching(false);
						toggleFetchData(fetch);
					});
			}
		},
		useWindow: false,
		threshold: 150,
		deps: [sliderContRef]
	});

	const onSearchChange = e => {
			const rawValue = e.target.value;
			const sanitized = enforceStrictASCII(rawValue);			
			search.onChange(sanitized);
	};

	const scrollHandler = (e) => {
		if (showCreateItem) {
			toogleSubHeaderShadow(e.target.scrollTop > 5);
		} else {
			setScrolled(e.target.scrollTop > 5);
		}
	}

	useOnScroll({
        callback : (e,scrollObj) => {
          if(scrollObj.currScroll.scrollTop){
            toogleSubHeaderShadow(true);
          }else{
            toogleSubHeaderShadow(false)
          }
        },
        element : !scrollEl ? null : scrollEl,
        deps: [scrollEl]
    })

	useEffect(() => {
		const timer = setTimeout(() => {
			const inp = document.querySelector('.input-container input');
			inp && inp.focus();
			inp && inp.click();
		}, 800);
		if(window){
            window.appHandler = (jsonStr) => {
                try {
                console.log('callback',jsonStr);
                const transformedJson = JSON.parse(jsonStr);
                const {eventType, redirectionurl} = transformedJson;
                if(redirectionurl){
                    window.location.replace(redirectionurl);
                }else if(eventType == "deviceback"){
                    if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                        const exitJson ={"action":"exit"};
                        JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                    }
                }
                } catch (e) {
                console.log(e)
                }
            };
			if(props.isJdSourceAndroid){
                pageLoad();
			}
			if (props.isJdBusinessIOS) {
				pageLoadForIos();
			}
        }
		if (sliderContRef && sliderContRef.current && sliderContRef.current.scrollTo)
			sliderContRef.current.scrollTo(0, 0);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		setAutoSuggestiontData(props.autoSuggestion.data);
	}, [props.autoSuggestion]);

	const wrapper = () => {
		return (
			<>
				{showCreateItem && searchText && (
					subHeader.parse ?
						subHeader.children
						:
						<div className={`${subHeader.class} ${subHeaderShadow ? " raised" : ""}`}
							style={{ top: `${headerOffSet}px` }} >
							<div className={styles["left-side"]}>
								<i className={`${styles["btn-style"]} ${"icon-plus"}`}></i>
							</div>
							<div className={styles["right-side"]} onClick={subHeader.onClick}>
								<span className={styles["text-blue"]}>{subHeader.text}</span>
								<span className={styles["text-style"]}>'{searchText}'</span>
							</div>
						</div>
				)}
				<>
					{!isBarcodeSearch &&
						autoSuggestiontData &&
						autoSuggestiontData.map((item, index) =>
							autoSuggestion.renderListItem ? (
								<div 
									className='suggestion-holder'
									onClick={()=>{
										if (sliderContRef && sliderContRef.current && sliderContRef.current.scrollTo){
											sliderContRef.current.scrollTo(0, 0);
										}
									}}
								>
									{autoSuggestion.renderListItem(
										item,
										index,
										historyHandler.closeCurrent
									)}
								</div>
							) :
								<ItemResult
									item={item}
									autoSuggestion={autoSuggestion}
									searchText={searchText} />
						)}
				</>
				{((searchText.length > minLength &&
					!autoSuggestiontData.length &&
					!search.loader && !noRsltBarcode && !isScanned)) &&  (
						<NoResultFound
							customHTML={props.noResultFoundHTML}
							notFoundText={props.notFoundText}
							manageTaxes={props.manageTaxes}
						/>
					)}
				{!searchText && !autoSuggestiontData.length && !props.hideHintText && (
					<SearchHint
						hintText={props.hintText}
						customClass={props.hintCustomClass}
						showItemSearchProdSer={props.showItemSearchProdSer}
					/>
				)}
			</>
		);
	}

	let checkAndShowInfo = () => {
		axios.get('/marketplace/omni-db-api/omni_services/userbarcodetag?docid='+props.session.docId).then(res => {
			if(res.data.status) {
				if(Object.keys(res.data?.results)?.length) {
					scanBarcodeFunc({
						cb: () => toggleBarcodeInfo(false)
					});
				}else {
					toggleBarcodeInfo(true);
				}
			}
		}).catch(err => console.log('BarcodeTagApi ERR : ',err))
	}

	let headerProps = {
		...header,
		className: `itemListHeader ${isScrolled ? ` rasied ${props.manageTaxes ? 'shadow-taxes' :''}` : ''}`,
		raised: isScrolled,
		heading: header.title || "",
		variant: header.variant,
		rightIcons: header.rightIconArr || [],
		searchBox: props.searchBox != undefined ? props.searchBox : true,
		searchVariant: search.searchVariant || "edit",
		showOnlySearch: props.showOnlySearch,
		fromAddEditItemSearch: props.fromAddEditItemSearch,
		autoFocus: !props.noAutoFocus,
		inputProps: {
			className: styles["input-container"],
			inputClass: search.class,
			leftIconClick: props.showOnlySearch ? (() => {
				if((props.isJdSourceAndroid || props.isJdBusinessIOS) && props.fromSeller === "true"){
                    window.location.href = 'https://jdext.php';
                }else{
					if(props.fromSeller){
						window.history.go(-2);
					}else{
						historyHandler.closeCurrent();
						props.customBack && props.customBack();
					}
                }
			}) : () => { console.log('hhhhhh');},
			leftIconClass: props.showOnlySearch
				? `icon-HDRback ${styles["back-icon"]}`
				: search.leftIcon
					? search.leftIcon
					: "",
			placeholder: search.placeholder,
			onChange: onSearchChange,
			isSearchLoading: search.loader,
			onClear: onSearchClear,
			val: searchText,
			rightHtm:
				isMobileApp && !searchText.length && !search.hideScanner ? (
					<span
						onClick={() => checkAndShowInfo()}
						className={"icon-barcode " + styles["barcode-icon"]}
					></span>
				) : null,
			maxLength: search.maxLength
		}
	};
	if(props.deviceData.isMobile && !props.manageTaxes){
		return (
			<div className={styles["item-list-slider"]}>
				<SliderHeader {...headerProps} />
				{bodyStyle ? <div className={`${bodyStyle}`}> {wrapper()}</div> : wrapper()}
				{showBarcodeInfo?
					<div className={styles['info-fixed-container']}>
						<img src={'https://image1.jdomni.in/jdomni_email/Android_Barcode_2202151856.png'} className={styles['barcode-img']} />
						<div className={styles['info-container']}>
							<span className={styles['heading-txt']}>Scan Product Barcode</span>
							<span className={styles['info-txt']}>Scan the barcode by keeping it focused in the center of the camera screen.</span>
							<Button className={'barcode-btn'} children={'Okay, Got it'} clickHandler={() => {
								scanBarcodeFunc({
									cb: () => toggleBarcodeInfo(false)
								});
							}}/>
						</div>
					</div>:null}
			</div>
		)
	}
	return (
		<div className={styles["item-list-slider"]}>
			<SliderWrapper
				updateScrollContRef={ref => {
					setSliderContRef(ref);
				}}
				onScroll={(e) => { scrollHandler(e) }}
				slideDirection="bottom"
				avoidPortal="true"
				header={headerProps}
				onHidden={() => props.onHidden(true)}
			>
				{bodyStyle ? <div className={`${bodyStyle}`}> {wrapper()}</div> : wrapper()}
			</SliderWrapper>
		</div >
	);
};

const mapStateToProps = state => {
	return {
		deviceData: state.library.deviceData,
		session: state.session,
		isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
		isJdBusinessIOS: state.session.isJdBusinessIOS,
		isJdSourceAndroid: state.session.isJdSourceAndroid
	};
};

export default connect(mapStateToProps)(ItemListSlider);
